import type { OrderDocumentType } from '@api/orders';

type TranslateFn = (key: string, params?: Record<string, string | number>) => string;

// Lowercase document nouns for mid-sentence interpolation ("…in the quotation").
const DOCUMENT_NAME_KEY: Record<OrderDocumentType, string> = {
  quotation: 'order_actions.generate_draft_dialog.document_quotation',
  confirmation: 'order_actions.generate_draft_dialog.document_confirmation',
  delivery_order: 'order_actions.generate_draft_dialog.document_delivery_order',
};

// Copy for the "some events are still draft" confirmation shown before generating
// a document. The event_id list and singular/plural verb agreement live inside
// the translations (interpolated), never string-concatenated here; the list join
// uses Intl.ListFormat so the Oxford comma is locale-driven, not hand-rolled.
export function buildDraftWarning(
  draftEvents: string[],
  documentType: OrderDocumentType,
  t: TranslateFn,
): { title: string; message: string } {
  const suffix = draftEvents.length === 1 ? 'one' : 'other';
  const document = t(DOCUMENT_NAME_KEY[documentType]);
  const events = new Intl.ListFormat('en', { style: 'long', type: 'conjunction' }).format(draftEvents);

  return {
    title: t(`order_actions.generate_draft_dialog.title_${suffix}`, {
      count: draftEvents.length,
      document,
    }),
    message: t(`order_actions.generate_draft_dialog.body_${suffix}`, { events }),
  };
}
